<div class="container-fluid py-4">
  <div class="row justify-content-center">
    <div class="col-4 col-md-2" *ngFor="let card of resumenCards; index as i">
      <div
        class="card card-stats"
        [ngClass]="{ 'card-stats__selected': i === 2 }"
        [routerLink]="card.route"
        [style.cursor]="card.route ? 'pointer' : 'default'"
      >
        <div class="card-body">
          <div class="row">
            <div class="col-12 col-md-7 col-lg-6">
              <div
                class="icon-big text-center text-dark rounded shadow"
                [ngClass]="card.bgClass"
              >
                <i [class]="card.icon"></i>
              </div>
            </div>
            <div class="col-7 d-flex flex-column justify-content-center">
              <p class="card-category mb-0">{{ card.label }}</p>
              <h4
                class="card-title mb-0"
                [ngClass]="{ 'text-dark': i === 2, 'text-white': i !== 2 }"
              >
                {{ card.value }}
              </h4>
            </div>
          </div>
        </div>
        <div class="card-footer">
          <div class="stats">
            <small [class]="i == 2 ? 'desc__selected' : 'desc'">{{
              card.desc
            }}</small>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="row justify-content-center mt-4">
    <div class="col-md-10">
      <div class="card shadow-sm">
        <!-- <div class="card-header bg-dark text-white d-flex justify-content-between align-items-center"> -->
        <div class="card-header card-header-icon">
          <div class="card-icon">
            <i class="material-icons">receipt</i>
          </div>
          <h4 class="card-title mb-0">
            {{ id ? "EDIT" : "NEW" }} SOCIAL CONTENT REQUEST
          </h4>
          <!-- <a routerLink="/marketing/social/contentRequests" class="btn btn-sm btn-outline-light">
              <i class="fas fa-arrow-left me-1"></i> BACK
            </a> -->
        </div>

        <div class="card-body">
          <form [formGroup]="form" (ngSubmit)="onSubmit()">
            <div class="row g-3">
              <!-- Basic Info -->
              <div class="col-md-4">
                <label class="form-label fw-bold small d-block"
                  >Request ID *</label
                >
                <input
                  type="text"
                  class="form-control form-control-sm"
                  formControlName="request_id"
                  [class.is-invalid]="isFieldInvalid('request_id')"
                />
              </div>

              <div class="col-md-4">
                <div class="form-group">
                  <label class="form-label fw-bold small d-block"
                    >Requested By Type *</label
                  >
                  <select
                    class="form-select form-select-sm"
                    formControlName="requested_by_type"
                  >
                    <option
                      *ngFor="let opt of requestedByTypeOptions"
                      [value]="opt"
                    >
                      {{ opt | uppercase }}
                    </option>
                  </select>
                </div>
              </div>

              <div class="col-md-4">
                <div class="form-group">
                  <label class="form-label fw-bold small d-block"
                    >Status *</label
                  >
                  <select
                    class="form-select form-select-sm"
                    formControlName="status"
                  >
                    <option *ngFor="let opt of statusOptions" [value]="opt">
                      {{ opt | uppercase }}
                    </option>
                  </select>
                </div>
              </div>

              <!-- Scope and Purpose -->
              <div class="col-md-4">
                <div class="form-group">
                  <label class="form-label fw-bold small d-block"
                    >Purpose *</label
                  >
                  <select
                    class="form-select form-select-sm"
                    formControlName="purpose"
                  >
                    <option *ngFor="let opt of purposeOptions" [value]="opt">
                      {{ opt | uppercase }}
                    </option>
                  </select>
                </div>
              </div>

              <div class="col-md-6">
                <div class="form-group">
                  <label class="form-label fw-bold small d-block"
                    >Vertical</label
                  >
                  <select
                    class="form-select form-select-sm"
                    formControlName="vertical"
                  >
                    <option value="">N/A</option>
                    <option *ngFor="let opt of verticalOptions" [value]="opt">
                      {{ opt | uppercase }}
                    </option>
                  </select>
                </div>
              </div>

              <div class="col-md-4">
                <div class="form-group">
                  <label class="form-label fw-bold small d-block"
                    >Geo Scope</label
                  >
                  <input
                    type="text"
                    class="form-control form-control-sm"
                    formControlName="geo_scope_value"
                  />
                </div>
              </div>

              <div class="col-md-4">
                <div class="form-group">
                  <label class="form-label fw-bold small d-block"
                    >Service Scope</label
                  >
                  <input
                    type="text"
                    class="form-control form-control-sm"
                    formControlName="service_scope"
                  />
                </div>
              </div>

              <div class="col-md-4">
                <div class="form-group">
                  <label class="form-label fw-bold small d-block"
                    >Industry Scope</label
                  >
                  <input
                    type="text"
                    class="form-control form-control-sm"
                    formControlName="industry_scope"
                  />
                </div>
              </div>

              <!-- Platforms -->
              <div class="col-12">
                <div class="form-group">
                  <label class="form-label fw-bold small d-block"
                    >Requested Platforms</label
                  >
                  <div class="d-flex flex-wrap gap-2 mt-1">
                    <button
                      type="button"
                      *ngFor="let platform of platformOptions"
                      class="btn btn-sm btn__platform-gen"
                      [ngClass]="
                        isPlatformSelected(platform)
                          ? 'btn-outline'
                          : 'btn-platform'
                      "
                      (click)="togglePlatform(platform)"
                    >
                      {{ platform | uppercase }}
                    </button>
                  </div>
                </div>
              </div>

              <!-- Risk and Timing -->
              <div class="col-md-2">
                <div class="form-group">
                  <label class="form-label fw-bold small d-block"
                    >Risk Hint</label
                  >
                  <select
                    class="form-select form-select-sm"
                    formControlName="risk_hint"
                  >
                    <option *ngFor="let opt of riskHintOptions" [value]="opt">
                      {{ opt | uppercase }}
                    </option>
                  </select>
                </div>
              </div>

              <div class="col-md-4">
                <div class="form-group">
                  <label class="form-label fw-bold small d-block"
                    >Source Trigger</label
                  >
                  <select
                    class="form-select form-select-sm"
                    formControlName="source_trigger"
                  >
                    <option
                      *ngFor="let opt of sourceTriggerOptions"
                      [value]="opt"
                    >
                      {{ opt | uppercase }}
                    </option>
                  </select>
                </div>
              </div>

              <div class="col-md-4">
                <div class="form-group">
                  <label class="form-label fw-bold small d-block"
                    >Due Date</label
                  >
                  <input
                    type="date"
                    class="form-control form-control-sm"
                    formControlName="due_date"
                  />
                </div>
              </div>

              <!-- Notes -->
              <div class="col-12">
                <div class="form-group">
                  <label class="form-label fw-bold small d-block">Notes</label>
                  <textarea
                    class="form-control form-control-sm"
                    formControlName="notes"
                    rows="3"
                  ></textarea>
                </div>
              </div>

              <div class="col-12 d-flex justify-content-end mt-4">
                <button
                  type="submit"
                  class="btn btn-dark btn-sm px-4 shadow-sm btn-platform"
                  [disabled]="!form.valid"
                >
                  Create
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
